import React, { useEffect} from "react";
import "../../styles/activities/Activities.css";
import TransportImg from "../../assets/images/Activities/Transport1.jpg";
import ConstructionImg from "../../assets/images/Activities/activity-btp1.jpg";
import LogistiqueImg from "../../assets/images/Activities/Logistique.jpg";
import ScolaireImg from "../../assets/images/Activities/Scolaire.jpg";
import DistributionImg from "../../assets/images/Activities/Distribution.jpeg";
import CommerciauxImg from "../../assets/images/Activities/Commerciaux.jpg";
import LocationImg from "../../assets/images/Activities/Location.jpg";
import Aos from "aos";
import { useTranslation } from "react-i18next";
import "aos/dist/aos.css";
import Popup from "reactjs-popup";
import PopActivitie from "./PopActivitie";

export default function Activies(props) {
  const { t } = useTranslation();
  useEffect(() => {
    Aos.init();
  }, []);

  const ActivitiesContent = [
    {
      id: 1,
      title: t("Activities.Transport"),
      description: t("Activities.Transport_desc"),
      image: TransportImg,
    },
    {
      id: 2,
      title: t("Activities.Construction"),
      description: t("Activities.Construction_desc"),
      image: ConstructionImg,
    },
    {
      id: 3,
      title: t("Activities.Logistique"),
      description: t("Activities.Logistique_desc"),
      image: LogistiqueImg,
    },
    {
      id: 4,
      title: t("Activities.Scolaire"),
      description: t("Activities.Scolaire_desc"),
      image: ScolaireImg,
    },
    {
      id: 5,
      title: t("Activities.Distribution"),
      description: t("Activities.Distribution_desc"),
      image: DistributionImg,
    },
    {
      id: 6,
      title: t("Activities.Location"),
      description: t("Activities.Location_desc"),
      image: LocationImg,
    },
    {
      id: 7,
      title: t("Activities.Commerciaux"),
      description: t("Activities.Commerciaux_desc"),
      image: CommerciauxImg,
    },
  ];

  return (
    <section className="Activities--container" ref={props.activiesRef}>
      <h1 className="Activities-title">
        {t("Activities.title")}{" "}
        <span className="SpanHighlightBlue">{t("Activities.title_2")}</span>
      </h1>
      <br />
      <div className="parent" data-aos="fade-up">
      {ActivitiesContent.map((activity, index) => (
  <Popup
    key={activity.id}
    trigger={
      <div className={`div${(index + 1) * 11}`}>
        <div className={`div${(index + 1) * 11}-background`}>
          <h1>{activity.title}</h1>
        </div>
      </div>
    }
  >
    {(close) => (
      <PopActivitie
        close={close}
        title={activity.title}
        desc={activity.description}
        image={activity.image}
      />
    )}
  </Popup>
))}



      </div>
    </section>
  );
}
